/*#########################################################
    拡張関数
#########################################################*/


/*#########################################################
    isset判定
#########################################################*/
window.isset = (data) => {
    if (typeof (data) == "object" && data !== null) {// null はオブジェクト判定されてしまうので除外
        if (data.length === 0 || Object.keys(data).length === 0) {
            return false;
        } else {
            return true;
        }
    } else {
        if (data === "" || data === null || data === undefined) {
            return false;
        } else {
            return true;
        }
    }
};

/*#########################################################
    clone
#########################################################*/
window.getCloneNode = (source) => {
    let clone = document.createElement('div');
    clone.innerHTML = source.innerHTML;
    return clone.childNodes[1]; // なんで1なのかわからん
}

/*#########################################################
    テンプレートを取得→valueをセットして返す
#########################################################*/
window.setValuesHtml = (template_id = null, d = null) => {
    if (!template_id || !d) return null;
    // テンプレートからコンテンツの取得
    const content = document.getElementById(template_id).content;
    let body = document.createElement('div');
    // クローンの作成
    let clone = document.importNode(content, true);
    for (let key in d) {
        const this_dom = clone.querySelector('[name="' + key + '"]');
        if (!this_dom || !d[key]) continue;
        if (this_dom.tagName == "SELECT") {
            let option_index = -1;
            const this_options = Array.from(this_dom.options);
            for (let i in this_options) {
                if (this_options[i].value == d[key]) {
                    option_index = i;
                    break;
                }
            }
            this_dom[option_index].setAttribute("selected", true);
        } else if (this_dom.tagName == "TEXTAREA") {
            this_dom.innerHTML = d[key];
        } else {
            switch (this_dom.getAttribute('type')) {
                case 'checkbox': // チェックボックスの場合
                    this_dom.setAttribute("checked", true);
                    break;
                default: // その他の場合
                    this_dom.setAttribute("value", d[key]);
            }
        }
    }
    // クローンをBODYに追加
    body.appendChild(clone);
    return body.innerHTML;
}

/*#########################################################
    テンプレートを取得→textをセットして返す
#########################################################*/
window.setTextHtml = (template_id = null, d = null) => {
    if (!template_id || !d) return null;
    // テンプレートからコンテンツの取得
    const content = document.getElementById(template_id).content;
    let body = document.createElement('div');
    // クローンの作成
    let clone = document.importNode(content, true);
    for (let key in d) {
        let this_dom = clone.querySelector('[data-content="' + key + '"]');
        if (!this_dom || !d[key]) continue;
        this_dom.innerHTML = d[key];
    }
    // クローンをBODYに追加
    body.appendChild(clone);
    return body.innerHTML;
}

/*#########################################################
    数字のカンマ区切り
#########################################################*/
window.toLocaleNum = (num) => {
    return Number(num).toLocaleString();
}

/*#########################################################
    指定した単位で切り上げる
    ceil(2.189,0.5) => 2.5
#########################################################*/
window.ceil = (value, step) => {
    step || (step = 1.0);
    var inv = 1.0 / step;
    return Math.ceil(value * inv) / inv;
}

/*#########################################################
    変数に代入されたドット記法のテキストデータから値を取得する
    getValueFromObject({a:{b:{c:1}}}, 'a.b.c') => 1
#########################################################*/
window.getValueFromObject = (object, key) => {
    return key.split('.').reduce((o, i) => o[i], object);
}



/*#########################################################
    要素を囲む・囲んでる要素を外す
#########################################################*/
window._wrap = (element, wrapper) => {
    element.parentNode.insertBefore(wrapper, element);
    wrapper.appendChild(element);
};
window._unwrap = (target) => {
    while (target.firstChild) {
        target.parentNode.insertBefore(target.firstChild, target);
    }
    target.remove();
};



/*#########################################################
    読み込み中処理
#########################################################*/
window.loading = (text="Loading...") => {
    document.querySelectorAll('.btn-loading').forEach((element) => {
        element.setAttribute("disabled", true);
        element.innerHTML = `
            <div class="loading-innner d-none"> ${element.innerHTML}</div>
            <span class="loading-spinner spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            ${text}`;
    });
};
window.loaded = () => {
    document.querySelectorAll('.btn-loading').forEach((element) => {
        element.removeAttribute("disabled");
        element.innerHTML = element.querySelector(".loading-innner").innerHTML;
    });
};